<div class="meet-preview-stage" #previewStage [attr.aria-busy]="loading ? true : null">
  <div class="meet-preview-canvas" [style.transform]="canvasTransform">
    <div class="meet-preview-scene">
      <div class="meet-preview-person" aria-hidden="true">
        <span class="meet-preview-person-head"></span>
        <span class="meet-preview-person-body"></span>
      </div>
      @if (!loading && layers.renderedUrl) {
        <img class="meet-preview-rendered" [src]="layers.renderedUrl" alt="" />
      }
      @if (!loading && !layers.renderedUrl && qrData) {
        <div class="meet-preview-qr-wrap" [ngStyle]="layers.qr.wrapStyle">
          <div
            class="meet-preview-qr-plate"
            [class.meet-preview-qr-plate--horizontal]="layers.qr.horizontal"
            [ngStyle]="layers.qr.plateStyle"
          >
            @if (layers.qr.fullOverlay && layers.caption) {
              <div
                [style.fontFamily]="textFontFamily"
                class="meet-preview-qr-text meet-preview-qr-text--caption"
                [style.fontSize.px]="layers.qr.fontCaption"
                [style.marginBottom.px]="layers.qr.horizontal ? 0 : layers.qr.plateGap"
              >
                {{ layers.caption }}
              </div>
            }
            <div class="meet-preview-qr-surface" [ngStyle]="layers.qr.surfaceStyle">
              <qrcode
                [qrdata]="qrData || fallbackQrData"
                [width]="layers.qr.qrSizePx"
                [errorCorrectionLevel]="overlayQr.errorCorrectionLevel"
                [margin]="overlayQr.margin"
                [colorDark]="overlayQr.colorDark"
                [colorLight]="overlayQr.colorLight"
                cssClass="meet-preview-qr-code"
              ></qrcode>
            </div>
            @if (!layers.qr.horizontal && !layers.qr.fullOverlay && layers.caption) {
              <div
                [style.fontFamily]="textFontFamily"
                class="meet-preview-qr-text meet-preview-qr-text--caption"
                [style.fontSize.px]="layers.qr.fontCaption"
              >
                {{ layers.caption }}
              </div>
            }
            @if (layers.qr.horizontal) {
              <div
                class="meet-preview-qr-identity meet-preview-qr-identity--horizontal"
                [ngStyle]="layers.qr.textColumnStyle"
              >
                @if (showEmployeeName && previewEmployeeName?.trim()) {
                  <div
                    [style.fontFamily]="textFontFamily"
                    class="meet-preview-qr-text meet-preview-qr-text--name meet-preview-qr-text--left"
                    [style.fontSize.px]="layers.qr.fontName"
                  >
                    {{ previewEmployeeName }}
                  </div>
                }
                @if (showJobTitle && previewJobTitle?.trim()) {
                  <div
                    [style.fontFamily]="textFontFamily"
                    class="meet-preview-qr-text meet-preview-qr-text--job meet-preview-qr-text--left"
                    [style.fontSize.px]="layers.qr.fontJob"
                  >
                    {{ previewJobTitle }}
                  </div>
                }
                @if (layers.caption) {
                  <div
                    [style.fontFamily]="textFontFamily"
                    class="meet-preview-qr-text meet-preview-qr-text--caption meet-preview-qr-text--left"
                    [style.fontSize.px]="layers.qr.fontCaption"
                  >
                    {{ layers.caption }}
                  </div>
                }
              </div>
            } @else if (
              (showEmployeeName && previewEmployeeName?.trim()) ||
              (showJobTitle && previewJobTitle?.trim())
            ) {
              <div class="meet-preview-qr-identity" [ngStyle]="layers.qr.identityStyle">
                @if (showEmployeeName && previewEmployeeName?.trim()) {
                  <div
                    [style.fontFamily]="textFontFamily"
                    class="meet-preview-qr-text meet-preview-qr-text--name"
                    [style.fontSize.px]="layers.qr.fontName"
                  >
                    {{ previewEmployeeName }}
                  </div>
                }
                @if (showJobTitle && previewJobTitle?.trim()) {
                  <div
                    [style.fontFamily]="textFontFamily"
                    class="meet-preview-qr-text meet-preview-qr-text--job"
                    [style.fontSize.px]="layers.qr.fontJob"
                  >
                    {{ previewJobTitle }}
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (!loading && !layers.renderedUrl && layers.logoUrl) {
        <div
          class="meet-preview-logo-wrap"
          [class.meet-preview-logo-wrap--above]="layers.logo.bare"
          [ngStyle]="layers.logo.wrapStyle"
        >
          <div
            class="meet-preview-logo-plate"
            [class.meet-preview-logo-plate--bare]="layers.logo.bare"
            [ngStyle]="layers.logo.plateStyle"
          >
            <img [src]="layers.logoUrl" alt="" class="meet-preview-logo" />
          </div>
        </div>
      }
    </div>
  </div>
  @if (loading) {
    <div class="meet-preview-overlay" aria-busy="true">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }
</div>
